package com.gloopgo.game.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.gloopgo.game.network.MultiplayerRepository
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import kotlin.time.Duration.Companion.milliseconds

data class ConnectingUiState(
    val isConnecting: Boolean = true,
    val isJoined: Boolean = false,
    val statusMessage: String = "Connecting to global arena...",
    val errorMessage: String? = null,
    val userId: String = ""
)

class ConnectingViewModel(
    private val repository: MultiplayerRepository
) : ViewModel() {

    private val _uiState = MutableStateFlow(ConnectingUiState())
    val uiState: StateFlow<ConnectingUiState> = _uiState.asStateFlow()

    fun joinGlobalWorld(playerName: String) {
        viewModelScope.launch {
            _uiState.value = ConnectingUiState(
                isConnecting = true,
                isJoined = false,
                statusMessage = "Joining global arena as $playerName..."
            )
            try {
                val uid = repository.signInAnonymously(playerName)
                repository.goOnline()
                repository.registerOrUpdateUserProfile(uid, playerName)
                delay(300.milliseconds) // Brief connection handshaking delay
                _uiState.value = _uiState.value.copy(
                    isConnecting = false,
                    isJoined = true,
                    statusMessage = "Joined!",
                    userId = uid
                )
            } catch (e: Throwable) {
                _uiState.value = _uiState.value.copy(
                    isConnecting = false,
                    isJoined = false,
                    errorMessage = e.message ?: "Failed to connect to arena. Please try again."
                )
            }
        }
    }

    fun reset() {
        _uiState.value = ConnectingUiState()
    }
}
